import React from "react";
import { Link } from "react-router-dom";
import { formatValue, formatAssetValue } from "@/lib/api";
import DmeTag from "@/components/DmeTag";

export default function ExposureTab({ ov }) {
  return (
    <div className="card-bordered overflow-hidden" data-testid="ptab-content-exposure">
      <div className="grid grid-cols-12 gap-2 px-4 py-2.5 text-[10px] tracking-[0.15em] text-[var(--text-3)] font-mono border-b border-[var(--border)]">
        <div className="col-span-4">PLAYER</div>
        <div className="col-span-4">EXPOSURE</div>
        <div className="col-span-4 text-right inline-flex items-center gap-1.5 justify-end">AVG VALUE <DmeTag /></div>
      </div>
      {ov.exposure.map(e => (
        <div key={e.player_id} className="grid grid-cols-12 gap-2 px-4 py-2.5 items-center text-sm border-b border-[var(--border)] last:border-0 hover:bg-white/5" data-testid={`exp-row-${e.player_id}`}>
          <div className="col-span-4 min-w-0">
            {e.position === "PICK" ? (
              <span className="truncate block">{e.name}</span>
            ) : (
              <Link to={`/app/players/${e.player_id}`} className="hover:text-[var(--accent)] truncate block">{e.name}</Link>
            )}
            <div className="text-[10px] tracking-widest text-[var(--text-3)]">{e.position === "PICK" ? "DRAFT PICK" : `${e.position} · ${e.team}`}</div>
          </div>
          <div className="col-span-4 flex items-center gap-2">
            <div className="flex-1 h-2 bg-black/40 rounded-sm overflow-hidden">
              <div className="h-full bg-[var(--accent)]" style={{ width: `${e.exposure_pct}%` }} />
            </div>
            <div className="font-mono text-xs w-24 shrink-0">{e.exposure_pct}% · {e.leagues_owned}/{e.total_leagues}</div>
          </div>
          <div className="col-span-4 text-right font-mono">{formatAssetValue(e.avg_value, e.position)}</div>
        </div>
      ))}
    </div>
  );
}
